// src/components/Header.jsx
import React, { useState, useRef, useEffect, useMemo } from "react";
import { IoNotificationsOutline } from "react-icons/io5";
import { useNavigate, Link } from "react-router-dom";
import Notificacion from "./Notificaciones/Notificacion";
import { useNotifications } from "./Notificaciones/NotificationsContext";
import { useAuth } from "../auth/AuthContext"; // 👈 ajusta ruta si hace falta

function getInitials(user) {
  if (!user) return "";

  const name =
    user.first_name+" "+user.last_name ||
    "";

  if (!name) return "";

  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }

  return (
    parts[0][0].toUpperCase() +
    parts[1][0].toUpperCase()
  );
}

const Header = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { notifications, markAsRead } = useNotifications();
  const { user } = useAuth(); // ✅ usuario desde contexto

  const userInitials = useMemo(
    () => getInitials(user),
    [user]
  );
  // console.log("iniciales: ",userInitials);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const notificaciones = notifications
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 5);

  return (
    <header className="flex items-center justify-end px-4 py-1">
      <div className="flex items-center space-x-4">

        {/* 🔔 Notificaciones */}
        {/* <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 transition"
        >
          <IoNotificationsOutline className="w-6 h-6" />
        </button> */}

        {isOpen && (
          <div
            ref={dropdownRef}
            style={{
              width: 342,
              maxHeight: "65vh",
              position: "absolute",
              right: 120,
              top: 80,
              background: "#F5F5F5",
              borderRadius: 8,
              border: "1px solid #E3E5E6",
              overflowY: "auto",
              padding: 16,
              zIndex: 1000,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 16 }}>
              Notifications
            </div>

            <Link
              to="/notificaciones"
              onClick={() => setIsOpen(false)}
              className="text-[#54B046] cursor-pointer absolute right-4 top-4"
            >
              View all
            </Link>

            {notificaciones.map((notif) => (
              <Notificacion
                key={notif.id}
                titulo={notif.title}
                mensaje={notif.description}
                tiempo={notif.timeLabel}
                tipoAccion={!!notif.cta}
                isUnread={notif.isUnread}
                onClick={() => markAsRead(notif.id)}
              />
            ))}
          </div>
        )}

        {/* 👤 Avatar */}
        <button
          onClick={() => navigate("/perfil")}
          aria-label={`Profile of ${user?.first_name || user?.email || 'user'}`}
          className="w-12 h-12 rounded-full bg-[#54B046] flex items-center justify-center text-white font-semibold shadow-md hover:opacity-90 transition"
        >
          {userInitials || "?"}
        </button>
      </div>
    </header>
  );
};

export default Header;
